module.exports = __webpack_public_path__ + "img/open-filters.ad684da2.svg";